import { getJobCategory } from 'app/employer/services/AutoSuggestServices';
import withInputErrorMessage from '../withInputErrorMessage';
import autosuggestFactory from './autosuggestFactory';
import withAutosuggestWrapper from './withAutosuggestWrapper';

export default withAutosuggestWrapper(
   withInputErrorMessage(
      autosuggestFactory({
         apiPromise: getJobCategory,
      }),
   ),
);

